module.exports = __webpack_public_path__ + "img/material-message.11ac81e0.svg";